module.exports = __webpack_public_path__ + "static/media/err_borrosoface.aa52ffd3.png";